// Components==============
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import { motion } from 'framer-motion';
import React from 'react';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import './Card.module.scss';
// =========================

export default function Card({ person }) {
    const slug = `/ambassadeur-popup/${person.id}`;
    const openModal = useOpenUrlModal(slug);

    return (
        <>
            <motion.div
                styleName="wrapper"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                initial={{ scale: 1 }}
                onClick={openModal}
            >
                <img src={person.image} alt={person.name} />
                <div styleName="content">
                    <p styleName="label">{person.label}</p>
                    <div styleName="info">
                        <h3>{person.name}</h3>
                        <p>{person.subtitle}</p>
                    </div>
                </div>
            </motion.div>
            <Modal slug={slug}>
                <div styleName="rich-text-wrapper">
                    <RichText richText={person.content} />
                </div>
            </Modal>
        </>
    );
}
